import { Component } from "react";

import { UserSelect } from "common/components/select/userselect";
import { MerchantSelect } from "common/components/select/merchantselect";

export class SessionFilters extends Component {
    static defaultProps = {
        merchant_ref: void 0,
        user_ref: void 0,
        updateFiltersHandler: () => {}
    };
    
    onMerchantChange = (newMerchantRef) => {
        this.props.updateFiltersHandler({
            merchant_ref: newMerchantRef,
            user_ref: this.props.user_ref
        });
    };
    
    onUserChange = (newUserRef) => {
        this.props.updateFiltersHandler({
            merchant_ref: this.props.merchant_ref,
            user_ref: newUserRef
        });
    };
    
    render() {
        return (
            <div className="filters">
                <MerchantSelect merchant_ref={this.props.merchant_ref} onChange={this.onMerchantChange} />
                <UserSelect merchant_ref={this.props.merchant_ref} user_ref={this.props.user_ref} onChange={this.onUserChange} />
            </div>
        );
    }
}
